const detectLinkYT =
  /(?:https?:\/\/)?(?:www\.?)?youtube\.com\/?(?:watch\?.*?v=([^&\s]+))?.*?[\s$]/g;
const detectTweets = /(https?:\/\/(?:www\.)?(twitter\.com|x\.com)\/(?:\w+\/)?status(?:es)?\/\d+)/g;

function embedYoutube(content) {
  return content.replace(
    detectLinkYT,
    "<iframe width='100%' height='450px' src='https://www.youtube.com/embed/$1' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>"
  );
}

function embedTwitter(content) {
  return content.replace(
    detectTweets,
    "<blockquote class='twitter-tweet'><a href='$1'></a></blockquote><script async src='https://platform.twitter.com/widgets.js' charset='utf-8'></script>"
  );
}

function generateDestacat(content) {
  const openTag = '<blockquote>';
  const closeTag = '</blockquote>';
  let newContent = content;

  if (newContent.includes(openTag) && newContent.includes(closeTag)) {
    newContent = newContent.replaceAll(openTag, "<div class='singlenoticia__destacat'><h2>");
    newContent = newContent.replaceAll(closeTag, '</h2></div>');
  }

  return newContent;
}

function generateEmbeds(content) {
  let newContent = content;
  newContent = embedYoutube(newContent);
  newContent = generateDestacat(newContent);
  newContent = embedTwitter(newContent);

  return newContent;
}
export default generateEmbeds;
